<template>
  <v-simple-table fixed-header height="67vh">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="simple-table-th">Type</th>
          <th class="simple-table-th">Previous Qty</th>
          <th class="simple-table-th">Qty</th>
          <th class="simple-table-th">Available Qty</th>
          <th class="simple-table-th">Date</th>
          <th class="simple-table-th">Related #</th>
          <th class="simple-table-th">Created At</th>
        </tr>
      </thead>

      <tbody>
        <!-- DATA ROWS -->
        <template v-if="inventoryData.length">
          <tr
            v-for="(row, index) in inventoryData"
            :key="index"
            :class="{
              'custom-border-top': index === 0,
              'orange_lighten-5': index % 2 === 0,
            }"
          >
            <!-- Serial -->
            <td class="simple-table-td pl-4">
              <v-chip
                v-if="row.bond_type"
                class="text-capitalize"
                label
                small
                :color="row.bond_type == 'inbond' ? 'green' : 'red'"
                text-color="white"
              >
                {{ row.bond_type }}
              </v-chip>
            </td>

            <!-- Inbond Date -->
            <td class="simple-table-td pl-4">
              <span class="font-weight-600" style="font-size: 18px !important">
                {{ row.previous_qty }}
              </span>
            </td>

            <!-- Inbond Doc -->
            <td class="simple-table-td pl-4 text-capitalize">
              <span
                class="font-weight-600"
                :style="{
                  color: row.bond_type === 'inbond' ? 'green' : 'red',
                  fontSize: '18px',
                }"
              >
                {{ row.bond_type === "inbond" ? "+" : "-" }}
                {{ row.adjust_qty }}
              </span>
            </td>

            <!-- Outbond Date -->
            <td class="simple-table-td pl-4">
              <span class="font-weight-600" style="font-size: 18px !important"
                >{{ row.available_qty }}
              </span>
            </td>

            <!-- Outbond Doc -->
            <td class="simple-table-td pl-4">
              <template v-if="row.is_outbond > 0">
                <span
                  class="font-weight-700"
                  :style="{ color: getColor(row.outbond_module_type) }"
                >
                  {{ formatDate(row.out_bond_date || row.added_at) }}
                </span>
              </template>
              <template v-else>
                <span
                  class="font-weight-700"
                  :style="{ color: getColor(row.inbond_module_type) }"
                >
                  {{ formatDate(row.in_bond_date) }}
                </span>
              </template>
            </td>
            <td class="simple-table-td pl-4">
              <template v-if="row.is_outbond > 0">
                <Barcode
                  :barcode="row.outbond_barcode"
                  :route="getRoute(row.outbond_module_type)"
                  :id="row.outbond_id"
                  :color="getColor(row.outbond_module_type)"
                />
              </template>
              <template v-else>
                <Barcode
                  :barcode="row.inbond_barcode"
                  :route="getRoute(row.inbond_module_type)"
                  :id="row.inbond_id"
                  :color="getColor(row.inbond_module_type)"
                />
              </template>
            </td>

            <!-- Created -->
            <td class="simple-table-td pl-4">
              <TableActivity v-if="!lodash.isEmpty(row.added_by)" :data="row">
                <template v-slot:first_letters>
                  {{ getFirstLetters(row.added_by?.display_name) }}
                </template>
                <template v-slot:display_name>
                  {{ row.added_by?.display_name }}
                </template>
                <template v-slot:date_time>
                  {{ formatDateTime(row.added_at) }}
                </template>
                <template v-slot:format_date_time>
                  {{ formatDate(row.added_at) }}
                  {{ formatTime(row.added_at) }}
                </template>
              </TableActivity>
            </td>
          </tr>
        </template>

        <!-- LOADING -->
        <template v-else-if="loading">
          <tr v-for="n in 3" :key="n">
            <td v-for="i in 6" :key="i">
              <v-skeleton-loader
                type="text"
                class="custom-skeleton table-rows-text"
              />
            </td>
          </tr>
        </template>

        <!-- EMPTY -->
        <tr v-else>
          <td colspan="6" class="text-center font-weight-500 font-size-16">
            <img
              :src="$assetURL('media/error/empty.png')"
              class="row-not-found-image"
            />
            Uhh... There are no records at the moment.
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";

export default {
  name: "InventorySerialTable",
  mixins: [CommonMixin],
  components: {
    Barcode,
    TableActivity,
  },
  props: {
    inventoryData: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    inbondDate: { type: String, default: null },
    inbondDoc: { type: String, default: null },
  },
  methods: {
    getColor(type) {
      if (type == "adjustment") {
        return "teal";
      } else if (type == "quotation") {
        return "orange";
      } else if (type == "invoice") {
        return "blue";
      } else if (type == "visit") {
        return "green";
      } else if (type == "product") {
        return "#24326d";
      } else if (type == "part") {
        return "#24326d";
      }else if (type == "purchase-order") {
        return "indigo";
      } 
      else {
        return "cyan";
      }
    },
    getRoute(type) {
      if (type == "product" || type == "part") {
        return false;
      }
      if (type == "adjustment") {
        return "adjustment.detail";
      } else if (type == "quotation") {
        return "quotation.detail";
      } else if (type == "invoice") {
        return "invoice.detail";
      } else if (type == "visit") {
        return "visit.detail";
      } else if (type == "purchase-order") {
        return "purchase.order.detail";
      } else {
        return false;
      }
    },
  },
};
</script>
